import { broadcastDrawStateSchema, type BroadcastDrawState } from '@qaytim/shared';

const BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

/**
 * OBS access is deliberately separate from `adminRequest`.
 *
 * A browser source has no admin session and receives a short-lived, draw-scoped token in the URL
 * fragment. Keeping this request path isolated prevents a future refactor from silently falling
 * back to the operator token in session storage.
 */
export async function fetchBroadcastDrawState(
  drawId: string,
  accessToken: string,
  signal?: AbortSignal,
): Promise<BroadcastDrawState> {
  const response = await fetch(`${BASE_URL}/broadcast/draws/${encodeURIComponent(drawId)}/state`, {
    cache: 'no-store',
    headers: {
      accept: 'application/json',
      authorization: `Bearer ${accessToken}`,
    },
    signal,
  });

  if (!response.ok) throw new Error(`Broadcast state request failed (${response.status})`);

  const parsed = broadcastDrawStateSchema.safeParse(await response.json().catch(() => null));
  if (!parsed.success) throw new Error('Broadcast state contract mismatch');
  return parsed.data;
}
